import { cn } from '@nexelem/utils';

type ResizeHandlerProps = {
  onMouseDown: React.MouseEventHandler<HTMLDivElement>;
  onTouchStart: React.TouchEventHandler<HTMLDivElement>;
  style?: React.CSSProperties;
  className?: string;
};

export const ResizeHandler = ({ onMouseDown, onTouchStart, style, className }: ResizeHandlerProps) => (
  <div
    style={style}
    className={cn(
      // -right-2.5 (-10px) centers the w-5 (20px) grab handle exactly over the right border edge
      'absolute top-0 -right-2.25 bottom-0 z-20 flex h-full w-5 cursor-col-resize items-center justify-center select-none hover:[&>span]:border-text-brand',
      className,
    )}
    onMouseDown={onMouseDown}
    onTouchStart={onTouchStart}
  >
    <span className="h-4 border-r border-border-primary transition-colors hover:border-text-brand" />
  </div>
);
